import { useEffect } from "react";
import {
  NOW_PLAYING,
  TMDB_API_OPTION,
  getMovieVideosUrl,
  getMoviesListURL,
} from "../utils/constants";
import { useDispatch } from "react-redux";
import {
  addNowPlayingMovies,
  setMainMovie,
  setMainTrailer,
} from "../store/movieSlice";

const useGetNowPlayingMovies = () => {
  const dispatch = useDispatch();
  // function to fetch movie clips
  const fetchAndSetTrailerVideo = async (movieId) => {
    const data = await fetch(getMovieVideosUrl(movieId), TMDB_API_OPTION);
    const videos = await data.json();
    const trailers = videos.results.filter((res) => res.type === "Trailer");
    const mainTrailer = trailers.length > 0 ? trailers[0] : videos[0];
    dispatch(setMainTrailer(mainTrailer));
  };
  // function to fetch now playing movies
  const getNowPlayingMovies = async () => {
    const data = await fetch(getMoviesListURL(NOW_PLAYING), TMDB_API_OPTION);
    const nowPlayingMovies = await data.json();
    dispatch(addNowPlayingMovies(nowPlayingMovies?.results));
    const mainMovie = nowPlayingMovies?.results[0];
    dispatch(setMainMovie(mainMovie));
    fetchAndSetTrailerVideo(mainMovie.id);
  };

  useEffect(() => {
    getNowPlayingMovies();
  }, []);
};

export default useGetNowPlayingMovies;
